import styled, { css } from 'styled-components'

import { f_1 } from '../../theme/type-scale'
import { proxima_nova } from '../../theme/font'
import { spacing_0_75, spacing_0_5, spacing_1 } from '../../theme/spacing'
import { border_radius_1, border_width_2 } from '../../theme/border'
import { transition } from '../../theme/animations'
import { line_height_1_5 } from '../../theme/typography'
import {
  white,
  gray_1,
  gray_6,
  gray_4,
  primaryForSite,
  secondaryForSite,
  softForSite,
} from '../../theme/colors'

export function makeButton (element) {
  return styled(element)`
    font-size: ${f_1};
    font-weight: bold;
    font-family: ${proxima_nova};
    border: 0;
    border-radius: ${border_radius_1};
    height: auto;
    display: inline-block;
    white-space: nowrap;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    outline: 0;
    cursor: pointer;
    transition: ${transition};
    padding: ${spacing_1} ${spacing_1};
    color: ${white};
    background: ${props => primaryForSite('careguide.com')};

    &:focus {
      outline: 1px dotted #212121;
      outline: 5px auto -webkit-focus-ring-color;
    }

    ${props => {
      if (props.thin) {
        return css`
          padding: ${spacing_0_5} ${spacing_1};
          line-height: ${line_height_1_5}; 
        `
      } else if (props.medium) {
        return css`
          padding: ${spacing_0_75} ${spacing_1};
          line-height: ${line_height_1_5}; 
        `
      }
    }}

    ${props => props.lightFont && css`
      font-weight: normal;
    `}

    ${props => props.flexible && css`
      min-width: 0;
      width: 100%;
    `}

    ${props => props.width && css`
      width: ${props.width};
    `}

    ${props => props.disabled && css`
      background: ${gray_4};
    `}

    &:hover {
      ${props => !props.disabled && css`
        background: ${props => secondaryForSite('careguide.com')};
        color: ${white};
        will-change: background-color;
        transition: ${transition};
      `}
      text-decoration: none;
    }

    ${props => {
      if (props.secondary) {
        return css`
          background: transparent;
          border: ${props => props.emphasis ? 
            css`${border_width_2} solid ${white}`
            : css`${border_width_2} solid ${gray_6}`};
          color: ${props => props.emphasis ? css`${white}` : css`${gray_6}`};
          padding: ${props => props.thin ?
            css`calc(${spacing_0_5} - ${border_width_2}) calc(${spacing_1} - ${border_width_2})`
            : css`calc(${spacing_1} - ${border_width_2}) calc(${spacing_1} - ${border_width_2})`};
          
          &:hover {
            background: ${props => {
              let background = 'transparent'

              if (!props.transparent) {
                 background = props.emphasis ? css`${softForSite('careguide.com')}` : css`${gray_1}`
              }

              return background
            }};
            border-color: ${props => props.emphasis ? css`${white}` : css`${gray_6}`};
            color: ${props => props.emphasis ? css`${white}` : css`${gray_6}`};
          }
        `
      } else if (props.emphasis) {
        return css`
          background: ${white};
          color: inherit;
          
          &:hover {
            background: ${gray_1};
            color: inherit;
          }
        `
      }  
    }}
  `
}
